import Request from '../modules/request.js'



const setDataContent = (code, data) => {
  console.log(`O CODIGO DE RESPOSTA É: ${code}`);

  if (code == 200) {
    document.getElementById('data-content').innerHTML = data;

  }
  if (code == 401) {
    console.log(code);

  }
}

const navigateTo = (path, exec = undefined) => {
  const request = new Request();

  request.get(`${path}`, (request, response) => {
    setDataContent(response.statusCode, response.data);
    if (exec != undefined) {
      alert('oi')
      console.log(exec);
      setTimeout(exec, 1500)

    }
  });
}

const showNotify = (data, time = false, redirect = null) => {
  if (document.getElementById('notify')) {
    document.getElementById('notify').remove();
  }
  let div = document.createElement('div');
  div.id = 'notify';
  div.className = 'notify';
  let span = document.createElement('span');
  span.innerHTML = data.message;
  div.append(span);
  document.body.append(div);
  if (time == true) {
    setTimeout(() => {
      document.getElementById('notify').remove();
    }, 3500);
  }
  if (redirect != null) {
    window.location.href = redirect;
  }
}

const getNewPosition = (row, posY) => {
  const cards = row.querySelectorAll(".itm:not(.dragging)");
  let result;

  for (var refer_card of cards) {
    const box = refer_card.getBoundingClientRect();
    const boxCenterY = box.y + box.height / 2;
    if (posY >= boxCenterY) result = refer_card;
  }

  return result;
}

let idWidth = null;
export default class Pmdsl {

  constructor() {
    this.last_department_marked = null;
    this.last_visuality_marked = null;
    this.visuality_id = null;
    this.authorize_mark = false;
    this.addimages_to = [];
  }

  closeModalUpload(){
    document.getElementById("modal-upload").style = "display:none;";
  }
  openModalUpload(){
    let modal = document.getElementById("modal-upload");
    modal.style = "display:block;";
  }

  uploadArchive(url){
    console.log('Upload de arquivo');
    const authenticity_token = document.getElementsByName('authenticity_token')[0].value;
    let form = document.getElementById('form-upload-file');
    const formData = new FormData(form);

    const data = {message: 'Aguarde', created: true}

    this.progressView();
    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      this.progressView(100, 'Concluido');
      showNotify(data, true, data.redirect);
      window.location.reload();
    })
    .catch(error => {
      const info = {message: 'Error, check logs for details', created: true}
      showNotify(info)
      console.error('Error:', error)
      this.progressView(98, 'Error');
      Pmdsl.navigator('archives', data.redirect);
    });
  }

  progressView(progress = 0, message = 'Aguarde') {
    const view = document.getElementById('progress-upload-view');
    const progressView = document.getElementById('progress-view');
    const percent = document.getElementById('percent-upload');
    const textProgress = document.getElementById('text-progress');
    view.style.display = 'block';
    if (progress == 100) {
      clearInterval(idWidth);
      percent.innerHTML = `${progress}%`;
      progressView.style.width = `${progress - 10}%`;
      textProgress.innerHTML = message;
      setTimeout(() => {
        view.style.display = 'none';
        textProgress.innerHTML = 'Aguarde';
        progressView.style.width = `${0}%`;
      }, 2500);
      return 1;
    }
    let width = 0;
    idWidth = setInterval(() => {
      width++;
      percent.innerHTML = `${width}%`;
      progressView.style.width = `${width - 10}%`;
      if (width >= 89) {
        clearInterval(idWidth);
      }
    }, 100);
  }

  addToOrder(id) {
    const orderList = document.getElementById('order-list');
    const insert = document.getElementById(id);
    if (insert.parentElement.id == 'order-list') {
      const list = document.getElementById('list');
      list.append(insert);
      return 0;
    }
    orderList.append(insert);
  }

  initDrag(id) {
    const rowitems = document.querySelectorAll(".rowitems");
    let tag = document.getElementById(id);
    document.addEventListener("dragstart", (e) => {
      e.target.classList.add("dragging");
    });
    document.addEventListener("dragend", (e) => {
      e.target.classList.remove("dragging");
    });

    rowitems.forEach((item) => {
      item.addEventListener("dragover", (e) => {
        const dragging = document.querySelector(".dragging");
        const applyAfter = getNewPosition(item, e.clientX);

        if (applyAfter) {
          applyAfter.insertAdjacentElement("afterend", dragging);
        } else {
          item.prepend(dragging);
        }
      });
    });
  }

  navigator(path_name, url) {

    switch (path_name) {
      case 'home':
        Dashboard.setCurrentPage('pmdsl-inicio');
        // navigateTo(url);
        window.location.href = url;
        break;
      case 'departments':
        // navigateTo(url);
        window.location.href = url;
        Dashboard.setCurrentPage('pmdsl-departments');
        break;
      case 'department':
        window.location.href = url;
        Dashboard.setCurrentPage('pmdsl-departments');
        
        break;
      case 'archives':
        // navigateTo(url);
        window.location.href = url;
        break;
      case 'archive':
        window.location.href = url;
        break;
      case 'archive-new':
        // navigateTo(url);
        window.location.href = url;
        break;
      case 'documents':
        Dashboard.setCurrentPage('pmdsl-documents');
        // navigateTo(url);
        window.location.href = url;

        break;
      case 'document':
        window.location.href = url;
        break;
      case 'document-new':
        window.location.href = url;
        // navigateTo(url, this.initEditor);
        break;
      case 'doc-example':
        window.location.href = url;
        break;
      case 'streams':
        Dashboard.setCurrentPage('pmdsl-streams');
        window.location.href = url;
        // navigateTo(url);
        break;
      case 'stream-new':
        // navigateTo(url);
        window.location.href = url;
        break;
      case 'visuality':
        //navigateTo(url);
        window.location.href = url;
        break;
    }

  }

  getDepartments() {
    const request = new Request();
    request.get('/dashboard/user/sys/departments/all', (request, response) => {
      setDataContent(response.statusCode, response.data);
    });
  }

  getVisualitys(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      setDataContent(response.statusCode, response.data);
    });
  }

  submitDepartment(url, redirect) {
    const form = document.querySelector("[data-remote]");
    // console.log(form);
    const authenticity_token = document.getElementsByName('authenticity_token')[0].value;
    const user_id = document.getElementById("department_user_id").value;
    const department_name = document.getElementById("department_name").value;
    let dt = {message: 'Aguarde', created: false}
    showNotify(dt, true);
    const request = new Request();
    let params = `authenticity_token=${authenticity_token}&department[name]=${department_name}&department[user_id]=${user_id}`;
    request.post(url, params, (request, response) => {
      let data = JSON.parse(response.data);
      console.log(data);
      if (data.created == true) {
        showNotify(data, true, data.redirect)
      } else {
        showNotify(data, true)
      }
    });
  }

  selectDepartment(id) {
    let department_field = document.getElementById('archive_department_id');
    department_field.value = id;

    if (this.last_department_marked != null) {
      this.last_department_marked.classList.remove('marked');
      this.last_department_marked.firstElementChild.firstElementChild.classList.remove('green');
      this.last_department_marked.firstElementChild.firstElementChild.classList.add('gray');
    }

    let departmentSelected = document.getElementById(`d-${id}`);
    departmentSelected.classList.add('marked');
    departmentSelected.firstElementChild.firstElementChild.classList.remove('gray');
    departmentSelected.firstElementChild.firstElementChild.classList.add('green');
    this.last_department_marked = departmentSelected;
  }

  selectVisuality(id, element_id) {
    this.visuality_id = id;
    if (this.last_visuality_marked != null) {
      this.last_visuality_marked.lastElementChild.lastElementChild.classList.remove('marked');
      this.last_visuality_marked.lastElementChild.lastElementChild.classList.remove('green');
      this.last_visuality_marked.lastElementChild.lastElementChild.classList.add('gray');
    }

    let visualitySelected = document.getElementById(element_id);
    visualitySelected.classList.add('marked');
    visualitySelected.lastElementChild.lastElementChild.classList.remove('gray');
    visualitySelected.lastElementChild.lastElementChild.classList.add('green');
    this.last_visuality_marked = visualitySelected;
  }

  updateVisuality() {
    // enviar requisicao para atualizar a visuality
  }

  floatMenu(id) {
    const floatMenu = document.getElementById(id);
    floatMenu.style = "display:block;z-index:100";
  }

  closeFloatMenu(id) {
    const floatMenu = document.getElementById(id);
    floatMenu.style = '';
  }

  getArchive(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      setDataContent(response.statusCode, response.data);
    });
  }

  goBack(url) {
    // navigateTo(url);
    window.location.href = url;
  }

  submitVisuality(url) {
    console.log('submit Visuality');
    let form = document.getElementById('form-visuality');
    const formData = new FormData(form);
    const data = {message: 'Aguarde', created: true}
    showNotify(data);

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.created == true) {
        showNotify(data, true, data.redirect);
      } else {
        showNotify(data, true);
      }
    })
    .catch(error => console.error('Error:', error));
  }

  removeVisuality(url)
  {
    console.log('remove visuality');
    
    const data = {message: 'Aguarde', created: true}
    showNotify(data);

    const authenticity_token = document.querySelector('meta[name="csrf-token"]').content;
    let params = `authenticity_token=${authenticity_token}`;
    const request = new Request();
    request.post(url, params, (request, response) => {
      let data = JSON.parse(response.data);
      console.log(data);
      showNotify(data, true);
      

    });

  }

  submitDocument(url) {
    console.log('submit Document');
    // Get content of a specific editor:
    const content_doc = tinyMCE.get('document_content_doc').getContent();
    document.querySelector('#document_content_doc').value = content_doc;
    let form = document.getElementById('form-document');
    const formData = new FormData(form);
    const data = {message: 'Aguarde', created: true}
    showNotify(data);

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.created == true) {
        showNotify(data, true, data.redirect);
      } else {
        showNotify(data, true);
      }
    })
    .catch(error => console.error('Error:', error));
  }

  addEventTo(target) {
    if (this.authorize_mark == true) {
      this.authorize_mark = false;
      target.classList.remove("mark");
      return 'removed';
    }
    if (this.authorize_mark == false) {
      this.authorize_mark = true;
      target.classList.add("mark");
      return 'added';
    }
  }

  addImage(id, image) {
    const button = document.getElementById(id);
    if (this.authorize_mark == true) {
      if (this.addimages_to.includes(image)) {
        // remove
        let arr = this.addimages_to.reduce((acc, item) => {
          if (item !== image) {
            acc.push(item);
          }
          button.firstElementChild.firstElementChild.classList.remove("green");
          button.firstElementChild.firstElementChild.classList.add("gray");
          return acc;
        }, []);
        this.addimages_to = arr;
        return this.addimages_to;
      }
      button.firstElementChild.firstElementChild.classList.remove("gray");
      button.firstElementChild.firstElementChild.classList.add("green");
      this.addimages_to.push(image);
    }
  }

  saveVisualityDocument(url, id, news_document_url) {
    const data = {message: 'Aguarde', created: true}
    showNotify(data);
    const orderList = document.getElementById('order-list');
    let items = orderList.children;
    let documentsId = []
    for (var item of items) {
      documentsId.push(item.attributes.documentid.value);
    }
    const documents = documentsId.toString();

    const authenticity_token = document.querySelector('meta[name="csrf-token"]').content;
    let params = `authenticity_token=${authenticity_token}&visuality[documentsids]=${documents}&visuality[id]=${id}`;
    const request = new Request();
    request.post(url, params, (request, response) => {
      let data = JSON.parse(response.data);
      console.log(data);
      showNotify(data, true);
      const content = document.getElementById('order-list').innerHTML;
      const r = new Request();

      r.get(news_document_url, (request, response) => {
        visualChannel.visual(response.data);
      });
    });
  }

  saveVisuality(url, id, news_screens_url, title) {
    const data = {message: 'Aguarde', created: true}
    showNotify(data)
    const orderList = document.getElementById('order-list');
    console.dir(orderList);
    let items = orderList.children;
    let imagesOrder = []
    for (var item of items) {
      imagesOrder.push(item.firstElementChild.firstElementChild.src);
    }
    const authenticity_token = document.querySelector('meta[name="csrf-token"]').content;
    const screens = imagesOrder.toString();
    const transiction_time = window.document.getElementById("transiction_time").value;
    const request = new Request();
    let params = `authenticity_token=${authenticity_token}&visuality[screens]=${screens}&visuality[id]=${id}&&visuality[transiction_time]=${transiction_time}`;
    request.post(url, params, (request, response) => {
      let data = JSON.parse(response.data);
      console.log(data);
      showNotify(data, true);
      const content = document.getElementById('order-list').innerHTML;
      const r = new Request();

      r.get(news_screens_url, (request, response) => {
        data = JSON.parse(response.data)
        consumer.subscriptions.subscriptions[0].visual(data.screens_html, data.screens_json, data.transiction_time);
      });
    });
  }

  openVisuality(url) {
    // Abre uma nova janela com características específicas
    window.open(url, '_blank', 'width=800,height=600,top=100,left=100');

  }

  getArchivesByDepartment(event, visuality_id, visuality_url) {
    const department_id = event.target.value;
    console.log(department_id);
    if (department_id == 'all') {
      console.log('carregar todas as imagens');
      this.navigator('visuality', visuality_url)
    } else {
      fetch(`/pmdsl-visualizador/images-department/${visuality_id}/${department_id}`, {
        method: 'get',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => response.text())
      .then(data => {
        console.log(data);
        document.getElementById('list').innerHTML = data;
      })
      .catch(error => console.error('Error:', error));
    }

  }

  getDeleteFile(url, fname, redirect) {
    fetch(url+'?file_name='+fname, {
      method: 'post',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ archive: {file_name: fname} })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      showNotify(data, true, redirect)
    })
    .catch(error => console.error('Error:', error));
  }

  deleteArchive(url, redirect) {
    fetch(url, {
      method: 'get',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.deleted == true) {
        this.navigator('archives', redirect);
      } else {
        showNotify(data);
      }
    })
    .catch(error => console.error('Error:', error));

  }

  deleteDepartment(url, redirect) {
    fetch(url, {
      method: 'get',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      this.navigator('departments', redirect);
    })
    .catch(error => console.error('Error:', error));

  }

  initEditor() {
    tinymce.init({
      license_key: 'gpl',
      selector: 'textarea#document_content_doc',
      plugins: 'image code',
      toolbar: 'undo redo blocks | link image | code | bold italic',
      /* enable title field in the Image dialog*/
      image_title: true,
      /* enable automatic uploads of images represented by blob or data URIs*/
      automatic_uploads: true,
      /*
        URL of our upload handler (for more details check: https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_url)
        images_upload_url: 'postAcceptor.php',
        here we add custom filepicker only to Image dialog
      */
      file_picker_types: 'image',
      /* and here's our custom image picker*/
      file_picker_callback: (cb, value, meta) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.addEventListener('change', (e) => {
          const file = e.target.files[0];

          const reader = new FileReader();
          reader.addEventListener('load', () => {
            /*
              Note: Now we need to register the blob in TinyMCEs image blob
              registry. In the next release this part hopefully won't be
              necessary, as we are looking to handle it internally.
            */
            const id = 'blobid' + (new Date()).getTime();
            const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
            const base64 = reader.result.split(',')[1];
            const blobInfo = blobCache.create(id, file, base64);
            blobCache.add(blobInfo);

            /* call the callback and populate the Title field with the file name */
            cb(blobInfo.blobUri(), { title: file.name });
          });
          reader.readAsDataURL(file);
        });

        input.click();
      },
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
    });
  }

  HideShowOrderList() 
  {
    const order_list = document.getElementById("order-list");
    const block_screens = document.getElementById("block-screens");
    if (order_list.classList.contains("hide-order-list") && window.innerWidth <= 620)
    {
      order_list.classList.remove("hide-order-list");
      order_list.style.display = "flex";
      block_screens.classList.remove("block-screens-resize");
      return;
    }
    if (window.innerWidth <= 620) {
      order_list.classList.add("hide-order-list");
      block_screens.classList.add("block-screens-resize");
    }
    
  }
}
